import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiCreateUserBadgeRequestBody,
  IApiCreateUserBadgeResponseBody,
  IApiDeleteUserBadgeResponseBody,
  IApiGetUserBadgeResponseBody,
  IApiGetUserBadgesResponseBody,
  IApiUpdateAssignedUserBadgeRequestBody,
  IApiUpdateAssignedUserBadgeResponseBody,
  IApiUpdateUserBadgeRequestBody,
  IApiUpdateUserBadgeResponseBody,
} from './UserBadgesApi.types';

export class UserBadgesApi {
  public constructor(private client: ApiClient) {}

  public async getAll(appId: string): Promise<IApiGetUserBadgesResponseBody> {
    const request: IApiJsonRequest = {
      path: '/userBadges',
      method: 'get',
    };

    const response = await this.client.fetchJson<IApiGetUserBadgesResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  public async get(
    appId: string,
    userBadgeId: string,
  ): Promise<IApiGetUserBadgeResponseBody> {
    const request: IApiJsonRequest = {
      path: `/userBadges/${userBadgeId}`,
      method: 'get',
    };

    const response = await this.client.fetchJson<IApiGetUserBadgeResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  public async create(
    appId: string,
    body: IApiCreateUserBadgeRequestBody,
  ): Promise<IApiCreateUserBadgeResponseBody> {
    const request: IApiJsonRequest = {
      path: '/userBadges',
      method: 'post',
      body,
    };

    const response =
      await this.client.fetchJson<IApiCreateUserBadgeResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async update(
    appId: string,
    userBadgeId: string,
    body: IApiUpdateUserBadgeRequestBody,
  ): Promise<IApiUpdateUserBadgeResponseBody> {
    const request: IApiJsonRequest = {
      path: `/userBadges/${userBadgeId}`,
      method: 'put',
      body,
    };

    const response =
      await this.client.fetchJson<IApiUpdateUserBadgeResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async updateAssigned(
    appId: string,
    userBadgeId: string,
    body: IApiUpdateAssignedUserBadgeRequestBody,
  ): Promise<IApiUpdateAssignedUserBadgeResponseBody> {
    const request: IApiJsonRequest = {
      path: `/userBadges/${userBadgeId}/user`,
      method: 'put',
      body,
    };

    const response =
      await this.client.fetchJson<IApiUpdateAssignedUserBadgeResponseBody>(
        request,
        {
          appId,
        },
      );

    return response.body;
  }

  public async delete(
    appId: string,
    userBadgeId: string,
  ): Promise<IApiDeleteUserBadgeResponseBody> {
    const request: IApiJsonRequest = {
      path: `/userBadges/${userBadgeId}`,
      method: 'delete',
    };

    const response =
      await this.client.fetchJson<IApiDeleteUserBadgeResponseBody>(request, {
        appId,
      });

    return response.body;
  }
}
